import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "lightning-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M10.5254 3.02574C11.5267 1.58109 13.7948 2.28712 13.7948 4.04777V9.18568H18.2115C19.6583 9.18568 20.5099 10.8115 19.6867 12.0017L13.4762 20.9729C12.4749 22.4176 10.2066 21.7119 10.2066 19.9512V14.8133H5.78985C4.3428 14.8133 3.48952 13.1878 4.3151 11.9967L10.5254 3.02574Z" }, null, -1)
  ])))
}
export default { render: render }